import { Button, IconButton, IconEditLine, Tooltip } from "@instructure/ui";
import { IconAddLine } from "@instructure/ui-icons";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CategoriesModalContent from "./CategoriesModalContent";

const CategoriesModal = ({
  data,
  loading,
  setLoader,
  title,
  service,
  loType,
  program,
  selected,
  buttonText,
  type,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      {type === "add" && (
        <Button
          id="add-category-button"
          color="primary"
          renderIcon={IconAddLine}
          onClick={() => setOpen(true)}
        >
          {buttonText}
        </Button>
      )}
      {type === "edit" && (
        <Tooltip renderTip={t("global.editCategory")}>
          <IconButton
            renderIcon={IconEditLine}
            screenReaderLabel={t("global.editCategory")}
            onClick={() => setOpen(true)}
          />
        </Tooltip>
      )}
      <CategoriesModalContent
        open={open}
        setOpen={setOpen}
        data={data}
        loading={loading}
        setLoader={setLoader}
        title={title}
        loType={loType}
        service={service}
        selected={selected}
        program={program}
      />
    </>
  );
};

export default CategoriesModal;
